import { Button, Icon } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

export function EmptyTableContent({
  hasDescription,
  createNew,
  feature,
  icon,
  description,
  title
}) {
  const { t } = useTranslation();

  return (
    <S.EmptyTableContent>
      {icon && <Icon name={icon} size="xxl" color="var(--color-accent-primary-strong)" />}

      <S.EmptyTableContentBody>
        <S.EmptyTableTitle variant="body2Semibold">
          {title ||
            (createNew
              ? t('emptyTableTitle1', { feature: t(feature).toLocaleLowerCase() })
              : t('emptyTableTitle2'))}
        </S.EmptyTableTitle>
        {hasDescription && (
          <S.EmptyTableDescription variant="body2" emphasis="weaker">
            {description || t('emptyTableDescription')}
          </S.EmptyTableDescription>
        )}
        {createNew && (
          <Button startIcon={<Icon name="add" />} onClick={createNew} size="sm">
            {t('addType', { type: t(feature) })}
          </Button>
        )}
      </S.EmptyTableContentBody>
    </S.EmptyTableContent>
  );
}

EmptyTableContent.propTypes = {
  hasDescription: PropTypes.bool,
  createNew: PropTypes.func,
  feature: PropTypes.string,
  icon: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string
};
